import { http } from '@/plugins/http';
import { reCaptchaToken } from '@/config';

export const send = ({ dispatch, state }, params) => {
  return reCaptchaToken().then(token => {
    params.recaptcha_token = token;

    return http
      .post('/form/send/', params)
      .then(data => {
        if (data.data?.data?.redirect.length > 0) {
          window.location.href = data.data?.data?.redirect;
        }

      })
      .catch(error => console.log(error));
  });
};
